export default __webpack_public_path__ + "static/media/image6.5b42da0e.jpg";